import { render, staticRenderFns } from "./labelAlign-editor.vue?vue&type=template&id=ae96f2f8&scoped=true&"
import script from "./labelAlign-editor.vue?vue&type=script&lang=js&"
export * from "./labelAlign-editor.vue?vue&type=script&lang=js&"
import style0 from "./labelAlign-editor.vue?vue&type=style&index=0&id=ae96f2f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae96f2f8",
  null
  
)

export default component.exports